import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, getGradeOptions, GradeLevelOptions } from "../../../../../../_helpers/Helpers";

export function HomeworkSourceEditForm({
  courses,
  gradeOptions,
  homeworkSource,    
  btnRef,
  getGradeCourses,
  setGradeOptions,
  saveHomeworkSource
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={homeworkSource}
      onSubmit={(values) => {
        if (values.pageNumber === "") values.pageNumber = null;
        saveHomeworkSource(values);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="gradeLevel">
            <Form.Label column sm={2}>
              Sınıf Düzeyi
            </Form.Label>
            <Col sm={10}>
              <CustomSelect 
                options={GradeLevelOptions}
                value={values.gradeLevel}
                onChange={option => {
                  const options = getGradeOptions(option.value);
                  setGradeOptions(options);
                  setFieldValue("gradeLevel", option.value);

                  if (options.length === 1) {
                    getGradeCourses(options[0].value);
                    setFieldValue("grade", options[0].value);
                  
                  } else if (!options.map(option => option.value).includes(values.grade)) {
                    getGradeCourses(null);
                    setFieldValue("grade", null);
                  }
                }}
              />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="grade">
            <Form.Label column sm={2}>
              Sınıf
            </Form.Label>
            <Col sm={10}>
              <CustomSelect
                options={gradeOptions}
                value={values.grade}
                onChange={option => {
                  getGradeCourses(option.value);
                  handleChange("grade")(option.value);
                }}
              />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="course">
            <Form.Label column sm={2}>
              Ders<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect 
                options={courses}
                value={values.courseId}
                onChange={option => handleChange("courseId")(option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Kaynak Adı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Kaynak Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="pageNumber">
            <Form.Label column sm={2}>
              Sayfa Sayısı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="number" min="1" value={values.pageNumber} placeholder="Sayfa Sayısı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}
    </Formik>
  );
}